var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsVolumeUpOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VolumeUp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page-1",
    d: "M78.31,20.66a40.6,40.6,0,0,1,0,57.4l-3.37-3.38a35.83,35.83,0,0,0,0-50.64ZM66.5,32.6a23.89,23.89,0,0,1,0,33.76L63.12,63a19.08,19.08,0,0,0,4.95-18.45A19.31,19.31,0,0,0,63.12,36Zm-52.69,5a4.77,4.77,0,0,1,4.77-4.77h7.5L53,13.93a2.39,2.39,0,0,1,3.76,2V83.11a2.39,2.39,0,0,1-3.76,2L26.08,66.21h-7.5a4.77,4.77,0,0,1-4.77-4.77ZM52,20.47,27.58,37.56h-9V61.44h9L52,78.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsVolumeUpOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_VolumeUp_Outline_Black_RGB.2a2ba8517c8f5208d22438376bd303a0.svg";
export { ForwardRef as ReactComponent };